<template>
  <v-form ref="form" @submit.prevent="$emit('submit', value)">
    <v-row class="d-flex justify-center mt-3">
      <v-col cols="4">
        <v-text-field
          label="Nome da Turma"
          v-model="value.nomeDaTurma"
          outlined
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-autocomplete
          v-model="value.anoSerie"
          label="Ano/Série"
          item-text="nome"
          item-value="id"
          outlined
          dense
          :items="lists.listAnoSeries"
        ></v-autocomplete>
      </v-col>
      <v-col cols="4">
        <v-autocomplete
          v-model="value.turno"
          label="Turno"
          item-text="descricao"
          item-value="id"
          outlined
          dense
          :items="lists.listTurnos"
        ></v-autocomplete>
      </v-col>
      <v-col cols="4">
        <v-autocomplete
          v-model="value.municipio"
          label="Município" 
          item-text="nome"
          item-value="codigo"
          outlined
          dense
          :items="lists.filteredListMunicipios"
          @change="handleMunicipioChange"
        ></v-autocomplete>
      </v-col>
      <v-col cols="4">
        <v-autocomplete
          v-model="value.escola"
          label="Escola"
          item-text="local"
          item-value="id"
          outlined
          dense
          :items="lists.filteredListEscolas"
          @change="handleEscolasChange"
        ></v-autocomplete>
      </v-col>
    </v-row>
    <div class="text-center">
      <v-col cols="12">
        <sca-submit-button />
        <sca-tooltip
          :text="'Limpar'"
          :icon="'mdi-eraser'"
          @click="resetForm()"
        ></sca-tooltip>
      </v-col>
    </div>
  </v-form>
</template>
<script>
export default {
  name: 'FiltrosDeListagemArticuladorRegional',
  props: {
    value: {
      type: Object,
      default: () => ({
        nomeDaTurma: null,
        anoSerie: null,
        turno: null,
        municipio: null,
        escola: null
      })
    },
    lists: {
      type: Object,
      default: () => ({
        listAnoSeries: [],
        listTurnos: [],
        listMunicipios: [],
        filteredListMunicipios: [],
        filteredListEscolas: []
      })
    }
  },
  watch: {
    value(v) {
      this.$emit('input', v);
    }
  },
  methods: {
    handleMunicipioChange(municipioCodigo) {
      const municipio = this.lists.listMunicipios.find(m => m.codigo === municipioCodigo);
      if (!municipio){
        this.lists.filteredListEscolas = this.lists.listEscolas;
        return;
      }

      this.lists.filteredListEscolas = this.lists.listEscolas.filter(escola => escola.municipio === municipio.nome);
    },
    handleEscolasChange(escolaId) {
      const escola = this.lists.listEscolas.find(e => e.id === escolaId);
      if (!escola) return;
      const municipio = this.lists.listMunicipios.find(m => m.nome === escola.municipio);

      this.value.municipio = municipio.codigo || null;
    },
    resetForm() {
      this.$resetForm();
      this.lists.listAcompanhamentoDeTurmas = [];
      this.lists.filteredListMunicipios = this.lists.listMunicipios;
      this.lists.filteredListEscolas = this.lists.listEscolas;
    },
  }
}
</script>